import React from "react";

export const PostFaqs = ({ faqs }) => {
  if (!faqs?.length) return null;
  return (
    <section className="mt-14" data-testid="blog-post-faqs">
      <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-brand-navy">Frequently asked questions</h2>
      <div className="mt-6 divide-y divide-brand-border border-y border-brand-border">
        {faqs.map((f, i) => (
          <details key={f.question} className="group py-5" data-testid={`blog-post-faq-${i}`}>
            <summary className="cursor-pointer list-none flex items-start justify-between gap-4 font-semibold text-brand-navy">
              {f.question}
              <span className="text-brand-accent transition-transform duration-200 group-open:rotate-45" aria-hidden>+</span>
            </summary>
            <p className="mt-3 text-brand-muted leading-relaxed">{f.answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
};
